import moment from "moment";

export enum ChallengeStates {
  rejected = "rejected",
  approved = "approved",
  pending = "pending",
  expired = "expired",
  draw = "draw",
  finished = "finished",
  win = "win",
  lose = "lose",
}

export const CHALLENGE_STATUSES = {
  rejected: "Declined",
  approved: "Accepted",
  pending: "Sent",
  expired: "Expired",
  draw: "Draw",
  finished: "Finished",
  win: "You Won",
  lose: "You Lost",
};

class ChallengeService {
  public formatDateToLiteral(date: Date) {
    return moment(date).format("MMMM D");
  }

  public formatDate(date: Date | moment.Moment) {
    return moment(date).format("YYYY-MM-DD");
  }

  public getChallengeStatusMessage(status: ChallengeStates) {
    return CHALLENGE_STATUSES[status];
  }

  public calculateFinalPoints(
    challengeStatus: ChallengeStates,
    score: number,
    wagerScore: number
  ): number | undefined {
    if (challengeStatus === ChallengeStates.draw) return score;
    if (challengeStatus === ChallengeStates.win) return score + wagerScore;
    if (challengeStatus === ChallengeStates.lose) return score - wagerScore;
    return;
  }

  public getExpirationDate(challengeDate, expirationDate, gameDate) {
    if(expirationDate) return moment.utc(expirationDate)
    if(moment(gameDate).endOf("day").diff(moment(challengeDate).endOf("day")) > 0) return moment.utc(gameDate).add(1, "days");
    return moment.utc(challengeDate).add(1, "days");
  }
}

export default new ChallengeService();
